// extracted by mini-css-extract-plugin
export var error = "EmailListModal-module--error--NhIcA";
export var form = "EmailListModal-module--form--6AMpH";
export var thumbnail = "EmailListModal-module--thumbnail--ToOh1";
export var thumbnailBadge = "EmailListModal-module--thumbnailBadge--eLbLJ";
export var welcomeContent = "EmailListModal-module--welcomeContent--Jwv4Y";